<template>
    <div class="wrapper">
        <div class="products" v-if="cartProducts.length > 0">
            <div class="product" v-for="product in cartProducts" :key="product.id">
                <div class="info">
                    <h1><span class="cartTitle">Shopping Cart Item:</span> {{product.product.name}}</h1>
                    <p>{{product.product.country}}</p>
                </div>
                <div class="image">
                    <img :src="'/images/products/'+product.product.image">
                </div>
                <div class="price">
                    <h2>{{product.product.price}}</h2>
                    <button class="auto" v-on:click="removeFromCart(product)">Remove</button>
                </div>
                <div class="qty">
                    Quantity in Cart: {{product.quantity}}
                </div>
            </div>
        </div>
        <div v-else>
            Please add products to the cart first and come back.
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CartList',
        props: {
            cartProducts: Array
        },
        methods: {
            removeFromCart: function(product) {
                if (product.quantity === 1) {
                    // debugger;
                    let idx = this.$root.$data.cart.findIndex(aProduct => aProduct.product.id === product.product.id);
                    // console.log(idx);
                    this.$root.$data.cart.splice(idx, 1);
                } else {
                    product.quantity--;
                }

            }
        }
    }
</script>

<style scoped>
    .cartTitle {
        color: green;
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .products {
        margin-top: 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
    }

    .product {
        margin: 10px;
        margin-top: 50px;
        width: 200px;
    }

    .product img {
        border: 2px solid #333;
        height: 250px;
        width: 200px;
        object-fit: cover;
    }

    .product .image {
        display: flex;
        justify-content: center;
        margin-bottom: 5px;
    }

    .info {
        background: #b4e3ff;
        color: #000;
        padding: 10px 30px;
        height: 80px;
    }

    .info h1 {
        font-size: 16px;
    }

    .info h2 {
        font-size: 14px;
    }

    .info p {
        margin: 0px;
        font-size: 10px;
    }


    .price {
        display: flex;
    }

    button {
        height: 50px;
        background: #000;
        color: white;
        border: none;
    }

    .auto {
        margin-left: auto;
    }

    .footer {
        font-size: 1em;
        font-weight: bold;
        opacity: .25;
        text-align: center;
        padding-top: 1.5em;
        padding-bottom: 1em;
        margin-top: 1em;
        transition: opacity 1s ease-in-out;
        border-top: 2px solid darkgray;
    }
</style>